// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__yZ_Rz","title":"Info_title__1xbQ-","selects":"Info_selects__1BQDS","requiredAsterisk":"Info_requiredAsterisk__1eKTL"};